import { memo } from 'react'
import { getSectorInfo } from '../../helpers/meetstandaard/sectorCatalog'
import toggleSectorSelection from '../../helpers/meetstandaard/toggleSectorSelection'

/**
 * Sectorcel in het projectenoverzicht: toont de sectoren van een organisatie
 * (CompagnyMeta.SelectedSectors) en laat de beheertenant ze aanpassen —
 * hetzelfde veld dat de organisatie zelf in Instellingen → Algemeen kiest.
 *
 * Een organisatie kan meerdere sectoren hebben, dus de cel is optellend:
 * kiezen voegt toe, het kruisje haalt weg. De cel schrijft niet zelf; de
 * ouder doet de write via een Cloud Function (cross-tenant).
 *
 * Zonder `docid` valt er niets te schrijven — dan tonen we alleen de labels,
 * anders zou een klik stil niets doen.
 *
 * @param {object} props
 * @param {{docid?: string, SelectedSectors?: string[]}} props.project - het CompagnyMeta-document
 * @param {string[]} props.selectableSectors - kiesbare sector-slugs (useAvailableSectors)
 * @param {boolean} props.canEdit - mag de huidige gebruiker sectoren wijzigen
 * @param {(docId: string, sectors: string[]) => void} props.onChange - krijgt de volledige nieuwe lijst
 */
const ProjectSectorsCell = ({ project, selectableSectors = [], canEdit = false, onChange = () => {} }) => {

    const docId = project?.docid
    const selected = Array.isArray(project?.SelectedSectors) ? project.SelectedSectors.filter(Boolean) : []
    const editable = canEdit && Boolean(docId)

    // Alleen wat nog niet gekozen is; een sector die wél op de tenant staat maar
    // niet in de keuzelijst zit (api loopt achter) blijft zichtbaar als chip.
    const addable = selectableSectors.filter((slug) => !selected.includes(slug))

    const change = (slug) => onChange(docId, toggleSectorSelection(selected, slug))

    return (
        <div className="project-sectors-cell">

            {selected.length === 0 && !editable && <span>—</span>}

            {selected.map((slug) => (
                <span key={slug} className="project-sector-chip">
                    {getSectorInfo(slug).label}
                    {editable && (
                        <button
                            type="button"
                            className="project-sector-chip__remove"
                            aria-label={`${getSectorInfo(slug).label} verwijderen`}
                            onClick={() => change(slug)}
                        >×</button>
                    )}
                </span>
            ))}

            {editable && addable.length > 0 && (
                <select
                    className="project-sectors-cell__add"
                    value=""
                    onChange={(e) => e.target.value && change(e.target.value)}
                >
                    <option value="">+ sector</option>
                    {addable.map((slug) => (
                        <option key={slug} value={slug}>{getSectorInfo(slug).label}</option>
                    ))}
                </select>
            )}
        </div>
    )
}

// De tabel rendert deze cel tot 250 keer, elk met een eigen keuzelijst, en
// hertekent élke rij zodra er ergens op de pagina iets binnenkomt (een
// CompagnyMeta-snapshot, de retentiescores, een van de tellingen). Zonder memo
// bouwt hij dan alle keuzelijsten opnieuw op. Werkt alleen zolang `onChange` een
// stabiele referentie is — zie useCallback in ProjectsOverview.jsx.
export default memo(ProjectSectorsCell)
